import { lazy } from "react";

const SystemStoresPage = lazy(() => import("@/widgets/system-admin/stores/StoresPage"));
const SystemStoreDetailPage = lazy(
  () => import("@/widgets/system-admin/stores/StoreDetailPage"),
);

const SystemStoreRoutes = {
  path: "stores",
  children: [
    { index: true, element: <SystemStoresPage /> },
    // `:adminStoreId`, deliberately not `:storeId` — the vendor route
    // `store/:storeId` owns that name and CustomBreadcrumb reads it, so reusing
    // it would fire admin store queries on every vendor page.
    { path: ":adminStoreId", element: <SystemStoreDetailPage /> },
  ],
};

export default SystemStoreRoutes;
